import type { DataGetter } from '@rea-argonaut/analytics';
import { trackEvent } from '@rea-argonaut/analytics';

interface TrackModalImpression {
  user_action?: string;
  modal_name: string;
  screen_name: string;
  modal_is_fullscreen: boolean;
  variant?: string;
  in_page_source: string;
}

export const trackModalImpression = ({
  user_action,
  modal_name,
  screen_name,
  modal_is_fullscreen,
  variant,
  in_page_source,
}: TrackModalImpression): void => {
  const event: DataGetter = () => ({
    schema: 'iglu:au.com.property/pca_modal_impression/jsonschema/1-0-0',
    data: {
      event_name: 'pca_modal_impression',
      user_action: user_action ?? null,
      modal_name,
      screen_name,
      modal_is_fullscreen,
      variant: variant ?? null,
      in_page_source,
    },
  });
  trackEvent(event);
};
